import createValidator from '../../lib/validator'

export default {
  computed: {
    loginValidator () {
      return createValidator({
        data: this.login,
        rules: {
          email: 'required|email',
          password: 'required'
        }
      }).validate()
    },

    registrationValidator () {
      return createValidator({
        data: this.registration,
        rules: {
          email: 'required|email',
          first_name: 'required|alphaDash',
          last_name: 'required|alphaDash',
          password: 'required|gte:8',
          password_confirmation: 'required|same:password'
        }
      }).validate()
    },

    accountRegistrationValidator () {
      return createValidator({
        data: { is_connected: this.is_connected },
        rules: { is_connected: 'required|accepted' }
      }).validate()
    }
  }
}
